import styles from './Required.module.scss';

import React from 'react';

export const Required: React.FC = () => {
  return <span className={styles.required}>*</span>;
};
